module.exports = __webpack_public_path__ + "img/user5.b29510d2.svg";